<ng-container *ngFor="let polygonOptions of polygonOptions;">
    <map-polygon [options]="polygonOptions"></map-polygon>
</ng-container>
